package one.healthium.bland.providers

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.remoteconfig.get
import dev.gitlive.firebase.remoteconfig.remoteConfig
import one.primehealth.app.TargetPlatform
import one.primehealth.app.targetPlatform
import one.healthium.domain.paywall.PaywallIdProvider

class AppPaywallIdProvider : PaywallIdProvider {

    private val remoteConfig = Firebase.remoteConfig

    override suspend fun getPaywallId(): String {
        remoteConfig.fetchAndActivate()
        val remotePaywallId = remoteConfig.get<String?>("paywall")
        return if (!remotePaywallId.isNullOrEmpty()) {
            return remotePaywallId
        } else {
            when (targetPlatform()) {
                TargetPlatform.Android -> "v101"
                TargetPlatform.iOS -> "v101"
                TargetPlatform.Web -> "v101"
            }
        }
    }
}